/*
 * Detecting scroll position
 */
function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
}



/*
 * ======= ready handler ======
 */

/*
 * Header transformation
 */
// let shrinkHeader = 124;
// $(window).scroll(function() {
//
//     let scroll = getCurrentScroll();
//
//     if ( scroll >= shrinkHeader ) {
//         $('.nav-outer').addClass('sticky');
//         $('body').addClass('sticky-padding');
//     }
//     else {
//         $('.nav-outer').removeClass('sticky');
//         $('body').removeClass('sticky-padding');
//     }
// });

$(document).ready(function(){

    const arrowLeftWhite = "<button class=\"slick-prev slick-arrow\" aria-label=\"Previous\" type=\"button\">" +
        "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 37.8 116\" style=\"enable-background:new 0 0 37.8 116;\" xml:space=\"preserve\">\n" +
        "<path fill=\"#FFFFFF\" d=\"M33.6,1.2c0.3-0.7,1-1.1,1.8-1.2c0.8,0.1,1.4,0.5,1.8,1.2c1,1.8,1,4,0,5.8L6,58l31.1,51c1,1.8,1,4,0,5.8\tc-1,1.6-2.6,1.6-3.5,0L0.7,60.9c-1-1.8-1-4,0-5.8L33.6,1.2z\"/>\n" +
        "</svg></button>";

    const arrowRightWhite = "<button class=\"slick-next slick-arrow\" aria-label=\"Next\" type=\"button\">" +
        "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 37.8 116\" style=\"enable-background:new 0 0 37.8 116;\" xml:space=\"preserve\">\n" +
        "<path fill=\"#FFFFFF\" d=\"M4.3,114.8c-0.3,0.7-1,1.2-1.8,1.2c-0.8-0.1-1.4-0.5-1.8-1.2c-1-1.8-1-4,0-5.8l31.1-51L0.7,7c-1-1.8-1-4,0-5.8 c1-1.6,2.6-1.6,3.5,0l32.9,53.9c1,1.8,1,4,0,5.8L4.3,114.8z\"/>\n" +
        "</svg></button>";

    const arrowLeftDark = "<button class=\"slick-prev slick-arrow\" aria-label=\"Previous\" type=\"button\">" +
        "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 37.8 116\" style=\"enable-background:new 0 0 37.8 116;\" xml:space=\"preserve\">\n" +
        "<path fill=\"#555555\" d=\"M33.6,1.2c0.3-0.7,1-1.1,1.8-1.2c0.8,0.1,1.4,0.5,1.8,1.2c1,1.8,1,4,0,5.8L6,58l31.1,51c1,1.8,1,4,0,5.8\tc-1,1.6-2.6,1.6-3.5,0L0.7,60.9c-1-1.8-1-4,0-5.8L33.6,1.2z\"/>\n" +
        "</svg></button>";

    const arrowRightDark = "<button class=\"slick-next slick-arrow\" aria-label=\"Next\" type=\"button\">" +
        "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 37.8 116\" style=\"enable-background:new 0 0 37.8 116;\" xml:space=\"preserve\">\n" +
        "<path fill=\"#555555\" d=\"M4.3,114.8c-0.3,0.7-1,1.2-1.8,1.2c-0.8-0.1-1.4-0.5-1.8-1.2c-1-1.8-1-4,0-5.8l31.1-51L0.7,7c-1-1.8-1-4,0-5.8 c1-1.6,2.6-1.6,3.5,0l32.9,53.9c1,1.8,1,4,0,5.8L4.3,114.8z\"/>\n" +
        "</svg></button>";

    $('.themepic-slider').slick({
        dots: true,
        arrows: false,
        autoplay: true,
        infinite: true,
        rows: 0
    });


    $('.mainslider--init').slick({
        dots: true,
        arrows: true,
        autoplay: true,
        slidesToShow: 1,
        infinite: true,
        slidesToScroll: 1,
        rows: 0,
        prevArrow: arrowLeftWhite,
        nextArrow: arrowRightWhite,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                }
            }
        ]
    });


    $('.teaser-3col__slider--init').slick({
        dots: false,
        arrows: true,
        autoplay: false,
        slidesToShow: 3,
        infinite: true,
        slidesToScroll: 1,
        rows: 0,
        prevArrow: arrowLeftDark,
        nextArrow: arrowRightDark,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false
                }
            }
        ]
    });

    $('#play').on('click', function(e) {
        e.preventDefault();
        $("#player")[0].src += "autoplay=1";
        $('#player').fadeIn(1000);
        $('#video-cover').fadeOut(1000);
        $('#play').hide();
    });

    /*
     * Custom mobile nav
     */
    $(".icon-unfold").click(function(){

        $(this).toggleClass("icon-unfold--down");

        $(this).parents().closest('li').find('dropdown').addClass("open");

        var dropdown = $(this).next();

        dropdown.slideToggle();

    });


    /*
     * Fancybox
     */
    $(".fancybox").magnificPopup({type:'image'});


    // $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    //     disableOn: 700,
    //     type: 'iframe',
    //     mainClass: 'mfp-fade',
    //     removalDelay: 160,
    //     preloader: false,
    //
    //     fixedContentPos: false
    // });

    $('form[id^=contact_]').submit(function (event) {
        event.preventDefault();

        $(this).find('button[type=submit]').prop('disabled', 'disabled');

        const data = {};
        $(this).serializeArray().forEach(o => {
            data[o.name] = o.value;
        });

        $.post('ajax/components/contact/ajax.php', $.extend({ action: 'formSubmit' }, data))
            .then(window.location.reload.bind(window.location));
    });

    $("#main-nav.collapse").on('show.bs.collapse', function(){
        $(".logo").css("top", "7px");
    });

    $("#main-nav.collapse").on('hide.bs.collapse', function(){
        $(".logo").css("top", "25px");
    });
});
